import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const DispatchAddress = ({data}) => {

  useEffect(() => {
    const values = data.slice(0,5).map(i => i.qty);
    const labels = data.slice(0,5).map(i => i.fact_address);

    GraphicUtils.barChart('dispatch-address', values, labels, false, true,  3);
    data && data.length > 0 &&  ReportUtils.createExportableTable(labels, values, "Despachos por endereços");

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">Despachos por endereços {data?.length >= 5 ? ' (TOP 5)' : ''}</span>
        <div className="mt-3" id="dispatch-address"></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default DispatchAddress;